import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { GlobalStyles } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Dashboard from "./components/Dashboard";
import DashboardMedecin from "./components/DashboardMedecin";
import CompanyEdit from "./components/Company/Edit";
import CompanyList from "./components/Company/List";
import SubscriptionList from "./components/Subscription/List";
import SubscriptionEdit from "./components/Subscription/Edit";
import PatientEdit from "./components/Patient/Edit";
import PatientList from "./components/Patient/List";
import PaymentList from "./components/Payment/List";
import SpecialistList from "./components/Specialist/List";
import SpecialistEdit from "./components/Specialist/Edit";
import VisitDetail from "./components/Visit/Detail";
import PatientDetail from "./components/Patient/Detail";
import Login from "./components/Login";
import Home from "./components/Home";
import Settings from "./components/Settings";
import AuditList from "./components/Audit/List";
import ReportList from "./components/Report/List";
import Protected from "./components/Protected";
import { useSelector } from "react-redux";
import { grey } from "@mui/material/colors";
import "./styles/global.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/es";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("es");
/*
brdeaux servital #401119
gris servital #3a3a3a
blanc cassé #f4edde
*/

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#401119",
    },
    secondary: {
      main: "#f4edde",
    },
    background: {
      default: "#3a3a3a",
    },
    warning: {
      main: "#E2925D",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
  },
  components: {
    MuiInputBase: {
      defaultProps: {
        disableInjectingGlobalStyles: true,
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: grey[300],
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          paddingTop: 0,
          paddingBottom: 0,
          lineHeight: "normal",
        },
      },
    },
  },
});

function App() {
  const isAuthenticated = useSelector((state) => state.login.tokenAccess);
  const user = useSelector((state) => state.user.user);
  return (
    <div className="App">
      <ThemeProvider theme={defaultTheme}>
        <GlobalStyles
          styles={{
            "@keyframes mui-auto-fill": { from: { display: "block" } },
            "@keyframes mui-auto-fill-cancel": { from: { display: "block" } },
          }}
        />
        <CssBaseline />
        <Routes>
          {isAuthenticated ? (
            <>
              <Route path="/" element={<Protected />}>
                <Route index element={user?.type === "medecin" ? <DashboardMedecin /> : <Dashboard />} />
                <Route path="/patients" element={<PatientList />} />
                <Route path="/patients/:id" element={<PatientDetail />} />
                <Route path="/visits/:id" element={<VisitDetail />} />
                {user?.type !== "viewer" && (
                  <Route path="/patients/edit" element={<PatientEdit />} />
                )}
                <Route path="/companies" element={<CompanyList />} />
                {user?.type !== "viewer" && (
                  <Route path="/companies/edit" element={<CompanyEdit />} />
                )}
                <Route path="/subscriptions" element={<SubscriptionList />} />
                {user?.type !== "viewer" && (
                  <Route
                    path="/subscriptions/edit"
                    element={<SubscriptionEdit />}
                  />
                )}
                {user?.type === "admin" && (
                  <Route path="/payments" element={<PaymentList />} />
                )}
                {user?.type === "admin" && (
                  <Route path="/settings" element={<Settings />} />
                )}
                {user?.type === "admin" && (
                  <Route path="/audit" element={<AuditList />} />
                )}
                {user?.type === "admin" && (
                  <Route path="/reports" element={<ReportList />} />
                )}
<Route path="/specialists" element={<SpecialistList />} />
                {user?.type !== "viewer" && (
                  <Route
                    path="/specialists/edit"
                    element={<SpecialistEdit />}
                  />
                )}
              </Route>

              {/* Add a default route for unmatched paths */}
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;
